import * as React from "react"
import {
  VideoWrapper,
  Video,
  VideoContainer,
  ControlButton,
  MobileControlButtonsContainer,
  MobileWrapper
} from "./settings.styled"
import {
  FaMicrophone,
  FaMicrophoneSlash,
  FaVideo,
  FaVideoSlash
} from "react-icons/fa"
import { IoCameraReverse } from "react-icons/io5"
import { SettingsProps } from "./settings.interfaces"
import { brandingSelector } from "../../recoil/atoms/room"
import { useRecoilValue } from "recoil"
import { Icon } from "../common/icons"
import DeniedPermissionWarning from "./DeniedPermissionWarning"
import useConfig from "src/hooks/useConfig"


export const MobileSettings = React.forwardRef<HTMLDivElement, SettingsProps>(
  (
    {
      devicesLists,
      handleChangeMuteDevice,
      handleChangeDevice,
      currentVideo,
      currentMutedDevices,
      tracks,
      isHomePage,
      isMobile,
      devicePermissionDenied
    },
    ref
  ) => {
    const roomStyles = useRecoilValue(brandingSelector)

    const _stylingDisabledIcon: React.CSSProperties = React.useMemo(() => {
      return {
        opacity: 0.5
      }
    }, [])

    const nextVideoDivice =
      devicesLists?.video[0]?.id === currentVideo?.id
        ? devicesLists?.video[1]
        : devicesLists?.video[0]

    const { localCamEnabled, localMuteEnabled } = useConfig()

    return (
      <MobileWrapper>
        {localCamEnabled === true && (
          <VideoWrapper>
            <Video>
              {currentMutedDevices?.video === true && (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    borderRadius: "50%",
                    zIndex: 10,
                    opacity: 0.5,
                    padding: "10px",
                    transform: "translate(-50%, -50%)",
                    background:
                      roomStyles.joinButtonBackgroundColor || "#1AC541"
                  }}
                >
                  <Icon
                    src={FaVideoSlash}
                    display="block"
                    color={roomStyles.joinPageButtonTextColor || "#FFFFFF"}
                    fontSize="2rem"
                  />
                </div>
              )}
              <VideoContainer
                ref={ref}
                isCamMuted={currentMutedDevices?.video}
                roomStyles={roomStyles}
              />
            </Video>
          </VideoWrapper>
        )}
        <MobileControlButtonsContainer>
          {localMuteEnabled === true && localCamEnabled === true && (
            <ControlButton
              roomStyles={roomStyles}
              isHomePage={isHomePage}
              offHover={isMobile}
              type="button"
              onClick={() =>
                handleChangeMuteDevice("audio", !currentMutedDevices.audio)
              }
              // disabled={tracks.audio ? false : true}
              // style={tracks.audio ? null : _stylingDisabledIcon}
              style={{ marginRight: localCamEnabled ? "15px" : "0" }}
            >
              <DeniedPermissionWarning isDenied={devicePermissionDenied.audio}>
                {currentMutedDevices.audio ? (
                  <FaMicrophoneSlash />
                ) : (
                  <FaMicrophone />
                )}
              </DeniedPermissionWarning>
            </ControlButton>
          )}
          {localCamEnabled === true && localMuteEnabled === true && (
            <ControlButton
              roomStyles={roomStyles}
              isHomePage={isHomePage}
              offHover={isMobile}
              type="button"
              onClick={() =>
                handleChangeMuteDevice("video", !currentMutedDevices.video)
              }
              style={{ marginRight: "15px" }}
              // disabled={tracks.video ? false : true}
              // style={tracks.video ? null : _stylingDisabledIcon}
            >
              <DeniedPermissionWarning isDenied={devicePermissionDenied.video}>
                {currentMutedDevices.video ? <FaVideoSlash /> : <FaVideo />}
              </DeniedPermissionWarning>
            </ControlButton>
          )}
          {localCamEnabled === true && localMuteEnabled === true && (
            <ControlButton
              roomStyles={roomStyles}
              type="button"
              isMobile={isMobile}
              offHover={isMobile}
              isHomePage={isHomePage}
              onClick={() => handleChangeDevice("video", nextVideoDivice)}
              disabled={
                devicesLists?.video.length > 1 && tracks.video ? false : true
              }
              style={
                devicesLists?.video.length > 1 && tracks.video
                  ? null
                  : _stylingDisabledIcon
              }
            >
              {<IoCameraReverse />}
            </ControlButton>
          )}
        </MobileControlButtonsContainer>
      </MobileWrapper>
    )
  }
)
